import { render, staticRenderFns } from "./PurchaseTableForm.vue?vue&type=template&id=5f6b0be3&"
import script from "./PurchaseTableForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseTableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports